import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2, Clock, ShieldOff, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

function Gate({ icon: Icon, title, message }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-white to-cyan-50 p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto mb-4"><Icon className="w-7 h-7 text-amber-600" /></div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-gray-600 mb-2">{message}</p>
        {user?.email && <p className="text-xs text-gray-400 mb-6">Signed in as {user.email}</p>}
        <Button variant="outline" onClick={logout} className="gap-2"><LogOut className="w-4 h-4" /> Sign Out</Button>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-teal-600" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;

  const isOwner = user.role === 'owner';
  const isActive = isOwner || user.status === 'active';

  if (!isActive) {
    if (user.status === 'blocked') {
      return <Gate icon={ShieldOff} title="Access Revoked" message="Your access to this workspace has been removed. Please contact the owner if you believe this is a mistake." />;
    }
    return <Gate icon={Clock} title="Access Pending" message="Your request is awaiting owner approval. You'll be able to sign in once an administrator approves your account." />;
  }

  if (requireAdmin && !(isOwner || user.role === 'admin')) {
    return <Navigate to="/" replace />;
  }
  return children;
}
